import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CardModule} from '../../components/card/card.module';
import {RouterModule} from '@angular/router';
import {SmartTableModule} from '../../modules/smart-table/smart-table.module';
import {MomentPipeModule} from '../../pipes/moment-pipe/moment-pipe.module';
import {BadgeExistModule} from '../../components/badge-exist/badge-exist.module';
import {IconsModule} from '../../components/icons/icons.module';
import {ReducerPipeModule} from '../../pipes/reducer-pipe/reducer-pipe.module';
import {NgxPopperModule} from 'ngx-popper';
import {PaginationModule} from '../../components/pagination/pagination.module';
import {PreloaderModule} from '../../components/preloader/preloader.module';
import {TableAccountComponent} from './table-account.component';
import {NgxJsonViewerModule} from 'ngx-json-viewer';
import {ParseJsonPipeModule} from '../../pipes/parse-json-pipe/parse-json-pipe.module';



@NgModule({
  declarations: [
    TableAccountComponent
  ],
    imports: [
        CommonModule,
        CardModule,
        RouterModule,
        SmartTableModule,
        MomentPipeModule,
        BadgeExistModule,
        IconsModule,
        ReducerPipeModule,
        NgxPopperModule,
        PaginationModule,
        PreloaderModule,
        NgxJsonViewerModule,
        ParseJsonPipeModule
    ],
  exports: [
    TableAccountComponent
  ]
})
export class TableAccountModule { }
